module.exports = __webpack_public_path__ + "static/img/solution_case1.68faa86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/solution_case1.png
// module id = amEc
// module chunks = 34